import { _notNil } from '@/littledash';

const alphaNumericCharacters: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

type PluralForms = { one: string } & Partial<Record<Intl.LDMLPluralRule, string>>;
type PluralHole = string | number | PluralForms;
type PluralTag = (strings: TemplateStringsArray, ...holes: Array<PluralHole>) => string;

export class StringUtils {
  static randomHexColor = (): string => {
    return '#000000'.replace(/0/g, function () {
      return (~~(Math.random() * 16)).toString(16);
    });
  };
  static randomString(length = 5): string {
    let result = '';

    for (let i = 0; i < length; i++) {
      result += alphaNumericCharacters.charAt(Math.floor(Math.random() * alphaNumericCharacters.length));
    }

    return result;
  }

  /**
   * Locale-independent lexicographic comparator for `Array#sort`. Unlike `String#localeCompare`, the
   * result does not depend on runtime locale settings, so sort order is stable across environments —
   * use it wherever deterministic ordering matters (e.g. graph layout).
   */
  static compareLexicographic = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0);

  static pluralize(count: number, word: string, plural?: string): string;
  static pluralize(count: number, options?: { locale?: string }): PluralTag;
  static pluralize(count: number, wordOrOptions?: string | { locale?: string }, plural?: string): string | PluralTag {
    const locale = typeof wordOrOptions === 'object' ? (wordOrOptions.locale ?? 'en') : 'en';
    const category = new Intl.PluralRules(locale).select(count);
    const pick = (hole: PluralHole): string =>
      typeof hole === 'object' ? (hole[category] ?? hole.other ?? `${hole.one}s`) : String(hole);

    if (typeof wordOrOptions === 'string') {
      return `${count} ${pick({ one: wordOrOptions, ...(_notNil(plural) ? { other: plural } : {}) })}`;
    }

    return (strings, ...holes) =>
      strings.reduce((sentence, text, index) => sentence + (index > 0 ? pick(holes[index - 1]) : '') + text, '');
  }
}
